import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list',
  imports: [CommonModule],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent {

  @Input() isList: boolean = false;
  @Input() listHeading!: string;
  @Input() listItems!: string[];
  @Input() listType: string = 'ul';

  ngOnInit() {
    console.log(this.listHeading);
    console.log(this.listItems);
    
  }

  processText(text: string): string {
    return text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
  }

}
